import { GET_USER_SUCCESS, DS_MTP_TUI_DX_Senior_Managers, DS_MTP_TUI_DX_Team_Managers } from 'Constants/userConstants';
import { getMsalIdToken } from 'Services/MsalTokenService';
import { jwtDecode } from 'jwt-decode';
import RestClient from 'Services/RestClientService';
import { normalizeStaffResponse } from 'Utils/ApiResponseHelper';
import logger from 'Services/MyTuiProfileCustomLogger';

export function getUser() {
  function getUserSuccess(user) {
    return {
      type: GET_USER_SUCCESS,
      data: { user },
    };
  }

  return async function (dispatch) {
    try {
      // Acquire ID token and decode it to get user profile
      const idToken = await getMsalIdToken();
      const profile = jwtDecode(idToken);
      const user = profile;

      // Preserve role checking logic (isManager)
      // Normalize roles: accept both underscore and space variants
      const normalizeRole = (role) => role.replace(/_/g, ' ').toLowerCase();
      const rolesToCheck = [DS_MTP_TUI_DX_Senior_Managers, DS_MTP_TUI_DX_Team_Managers];
      const normalizedUserRoles = user.roles.map(normalizeRole);
      user.isManager = rolesToCheck.some((role) => normalizedUserRoles.includes(normalizeRole(role)));

      // get variable from localStorage
      const isLocalStorageManager = localStorage.getItem('isManager') === 'true';
      if (isLocalStorageManager) user.isManager = true;

      // Preserve staff fetching logic
      let params = new URLSearchParams({ tuiEmail: user.email });
      let staffResult = await RestClient.Get(`staff?${params}`);
      // Normalize staff response
      const staffArray = normalizeStaffResponse(staffResult);
      const staffData = staffArray[0];
      user.staffId = staffData ? staffData.staffID : null;

      dispatch(getUserSuccess(user));
    } catch (error) {
      // Add error handling for token acquisition
      logger.error('Error in getUser action:', error);
      throw error;
    }
  };
}
